module.exports = __webpack_public_path__ + "img/sisterhood-text.44d14350.svg";